<section>
  <h1>{{ 'GDPR.COOKIE-DIALOG.TEXT.LAUNCHER-TITLE' | translate }}</h1>
  <span
    class="body-s"
    [innerHTML]="'GDPR.COOKIE-DIALOG.TEXT.LAUNCHER-TEXT' | translate | gdprLink"
  ></span>
</section>

<ui-feedback-footer
  primaryDataTest="gdpr-button"
  secondaryDataTest="cancel-gdpr-button"
  [primaryConfig]="gdprBtnConfig"
  [secondaryConfig]="cancelBtnConfig"
  (handlePrimaryClick)="submit()"
  (handleSecondaryClick)="dismiss()"
/>
